import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '../button/button.component';
import Grid from '@mui/material/Grid';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
  </Box>
);


export default function OutlinedCard(props) {

  const buttonDisplay = props.buttonText?true:false;
  //check if you are passing any value for buttonText, only then render Button
  //bigCardDisplay is to decide whether to render a big card or small card. If passed, then will render 
  
  return (
    <Box sx={props.bigCardDisplay?{ minWidth: 500, maxWidth:700 }:{ minWidth: 500, maxWidth:600 }}>
      <Card sx={props.sx} variant="outlined">
        <CardContent>
          <Typography variant="h3" component="div">
            {props.title}
          </Typography>
        </CardContent>
        <CardContent>
          <Typography variant="sub" component="div">
            {props.content}
          </Typography>
        </CardContent>
        <CardContent>
          {
            props.linkTexts?(props.linkTexts.map((linkText,index) => (<div style={{margin:'0.5rem'}} key={index}><a target="_blank" rel="noopener noreferrer" href={`${linkText}`} key={index}>{linkText}</a></div>))):null
            //conditionally render anchor links if passed as prop
          }
        </CardContent> 
        <CardActions>
          <Grid container justifyContent="center">
          {buttonDisplay?<Button buttonLink={props.buttonLink}>{props.buttonText}</Button>:null}
          </Grid>
        </CardActions>
      </Card>
    </Box>
  );
}